<h2 class="popup-heading" mat-dialog-title>{{ title }}</h2>
<div class="content">
  <div class="my-show-table">
    <div class="mat-elevation-z8 ex">
      <div class="billing-table">
        <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8 my-custom-table">
          <ng-container matColumnDef="card_brand">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Payment Method </th>
            <td mat-cell *matCellDef="let record">
              {{ record.card_brand ? capitalize(record.card_brand) : '--' }} 
            </td>
          </ng-container>
          <ng-container matColumnDef="subscription_plan">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Subscription </th>
            <td mat-cell *matCellDef="let record">
              {{ getPlanName(record.subscription_plan) }}
            </td>
          </ng-container>
          <ng-container matColumnDef="subscription_status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Status Message </th>
            <td mat-cell *matCellDef="let record">
              <ng-container *ngIf="record.failure_message">
                {{ capitalize(record.failure_message) }}
              </ng-container>
              <ng-container *ngIf="!record.failure_message">
                <ng-container *ngIf="record.payment_status === 'paid'">
                  Next Tier Charge - Successful
                </ng-container>
                <ng-container *ngIf="record.payment_status !== 'paid'">
                  {{ record.payment_status === 'succeeded' ? 'Successful' : record.payment_status === 'canceled' ?
                  'Canceled' : capitalize(record.payment_status) }}
                </ng-container>
              </ng-container>
            </td>
          </ng-container>
          <ng-container matColumnDef="amount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Amount </th>
            <td mat-cell *matCellDef="let record">
              ${{ record.amount }}
            </td>
          </ng-container>
          <ng-container matColumnDef="transaction_date">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Transaction Date\Time </th>
            <td mat-cell *matCellDef="let record">
              <!-- {{ getFormattedDate(record.transaction_date) }} -->
              {{ record.transaction_date | date:'short' }}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayed_columns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayed_columns;"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td colspan="5" class="mat-cell">{{ loading ? 'Loading...' : 'No Transactions.' }}</td>
          </tr>
        </table>
      </div>
   <mat-paginator [class]="total_reports > 5 ? '' : 'hidden_dropdown'"[pageSizeOptions]="[5]"[pageSize]="5"aria-label="Select page of the records"></mat-paginator></div>
  </div>
</div>